<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <h6 class="mb-2 ms-2">Horas Facturables / No Facturables por Proyecto</h6>
                    </div>
                    <div class="card-body">
                        <div class="search-container mb-3">
                            <input type="text" v-model="searchQuery" placeholder="Buscar por proyecto o cliente"
                                class="form-control" />
                        </div>

                        <div class="accordion" id="projectsAccordion">
                            <div v-for="(project, index) in paginatedProjects" :key="index" class="accordion-item">
                                <h6 class="accordion-header" :id="'heading' + index">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        :data-bs-target="'#collapse' + index" aria-expanded="false"
                                        :aria-controls="'collapse' + index" @click="toggleIcon(index)">

                                        <span class="date-title d-flex align-items-center">
                                            {{ project.client }} | {{ project.project }} |
                                            <i
                                                :class="isOpen[index] ? 'ni ni-bold-up ms-2' : 'ni ni-bold-down ms-2'"></i>
                                        </span>
                                    </button>
                                </h6>
                                <div :id="'collapse' + index" class="accordion-collapse collapse"
                                    :aria-labelledby="'heading' + index" data-bs-parent="#projectsAccordion">
                                    <div class="accordion-body p-3">
                                        <!-- Muestra la gráfica solo si los datos ya están cargados -->
                                        <ProjectPieChart v-if="billableTimeData" :data="billableTimeData" />
                                        <p v-else>Cargando datos de tiempo...</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <nav class="pagination-container mt-4">
                            <ul class="pagination">
                                <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                    <a class="page-link" @click="currentPage > 1 && currentPage--">«</a>
                                </li>
                                <li class="page-item" v-for="page in totalPages" :key="page"
                                    :class="{ active: currentPage === page }">
                                    <a class="page-link" @click="currentPage = page">{{ page }}</a>
                                </li>
                                <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                                    <a class="page-link" @click="currentPage < totalPages && currentPage++">»</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import ProjectPieChart from './components/charts/ProjectPieChart.vue'

const API_BASE_URL = process.env.VUE_APP_BASE_URL
const token = localStorage.getItem('authToken')

const searchQuery = ref('')
const currentPage = ref(1)
const itemsPerPage = 10

const projects = ref([])

const fetchProjects = async () => {
    try {
        const res = await axios.post(`${API_BASE_URL}/projects`, {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        projects.value = res.data
    } catch (error) {
        console.error('Error al obtener los proyectos:', error)
    }
}

const filteredProjects = computed(() => {
    return projects.value.filter(p =>
        (p.project?.toLowerCase().includes(searchQuery.value.toLowerCase()) || '') ||
        (p.client?.toLowerCase().includes(searchQuery.value.toLowerCase()) || '') ||
        (p.activity?.toLowerCase().includes(searchQuery.value.toLowerCase()) || '')
    )
})


const totalPages = computed(() =>
    Math.ceil(filteredProjects.value.length / itemsPerPage)
)

const paginatedProjects = computed(() => {
    const start = (currentPage.value - 1) * itemsPerPage
    return filteredProjects.value.slice(start, start + itemsPerPage)
})

// Estado para controlar qué acordeón está abierto
const isOpen = ref([]);

const billableTimeData = ref({})

const fetchBillableTime = async (projectId) => {
    try {
        const res = await axios.post(`${API_BASE_URL}/project-billable-time`, {
            project_id: projectId
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        billableTimeData.value = res.data
    } catch (error) {
        console.error(`Error al obtener tiempos del proyecto ${projectId}:`, error)
    }
}

const toggleIcon = (index) => {
    const project = paginatedProjects.value[index]
    isOpen.value[index] = !isOpen.value[index]

    if (isOpen.value[index] && !billableTimeData.value[project.project_id]) {
        fetchBillableTime(project.project_id)
    }
}

onMounted(fetchProjects)
</script>

<style scoped>
.search-container {
    display: flex;
    justify-content: center;
}

.form-control {
    max-width: 400px;
    border-radius: 20px;
    padding: 8px 15px;
}

/* Estilos de los acordeones */
.accordion-item {
    border: 1px solid #ddd;
    margin-bottom: 10px;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
}

.accordion-button:hover {
    background: #fb6340;
    color: white;
}

.accordion-button {
    background: white;
    color: gray;
    font-weight: bold;
    border: none;
    transition: background 0.3s ease;
}

.pagination-container {
    display: flex;
    justify-content: center;
}

.page-item .page-link {
    border-radius: 5px;
    color: #fb6340;
}

.page-item.active .page-link {
    background-color: #fb6340;
    border-color: #fb6340;
    color: white;
}

.page-item.disabled .page-link {
    color: #bbb;
}
</style>